
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/brand/details",
      function () {
        return require("private-next-pages/settings/brand/details.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/brand/details"])
      });
    }
  